import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import '../styles/navbar.css';

const links = [
  { name: 'About', target: 'about' },
  { name: 'Projects', target: 'projects' },
  { name: 'Skills', target: 'skills' },
  { name: 'Research', target: 'research' },
  { name: 'Certifications', target: 'certifications' },
  { name: 'Contact', target: 'contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setOpen(!open);
  const closeMenu = () => setOpen(false);

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <Link
        to="profile"
        smooth
        duration={500}
        className="logo"
        onClick={() => {
          window.history.pushState(null, "", "/");
          closeMenu();
        }}
      >
        Ashwin Dumane
      </Link>

      <nav className={`nav ${open ? 'active' : ''}`}>
        {links.map((link) => (
          <Link
            key={link.target}
            to={link.target}
            smooth
            offset={-70}
            duration={500}
            onClick={() => {
              // ✅ Change URL without hash
              window.history.pushState(null, "", `/${link.target}`);
              closeMenu();
            }}
            activeClass="active-link"
            spy={true}
          >
            {link.name}
          </Link>
        ))}
      </nav>

      <button
        className={`hamburger ${open ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </header>
  );
}
